export const EMAIL_PARAM = 'email';
export const ACCOUNT_VERIFIED = 'accountVerified';
export const TOKEN_PARAM = 'token';

export const BG_IMAGE_SRC = '/chat-session-bg.png';

export const DEFAULT_AGENT_NAME = 'consult';

export const UserRoles = {
  Admin: 'admin',
  Doctor: 'doctor',
} as const;

export const AccountTypes = {
  Doctor: 'doctor',
  Clinic: 'clinic',
} as const;

export const SelectValues = {
  Loading: 'loading',
  Empty: 'empty',
} as const;

export const PlatformRoles = {
  PlatformAdmin: 'platform_admin',
  PlatformSupport: 'platform_support',
  PlatformFinance: 'platform_finance',
} as const;

export type PlatformRole = (typeof PlatformRoles)[keyof typeof PlatformRoles];

export const CLINIC_EDI_TOOLTIP =
  'This identifies the clinic record. ' +
  'Reports use each doctor’s Secure Messaging ID in Settings.';
